'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'fish-bones';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e304';
var svgPathData = 'M62.1 248l81.9 0 0-96 16 0 0 96 80 0 0-96 16 0 0 96 80 0 0-96 16 0 0 96 64 0 0-136 32 0 128 144-128 144-32 0 0-136-64 0 0 96-16 0 0-96-80 0 0 96-16 0 0-96-80 0 0 96-16 0 0-96-81.9 0-43.5 116 15.4 15.4 62-41.3 0 19.2-64 42.7-32-32 48-128-48-128 32-32 64 42.7 0 19.2-62-41.3-15.4 15.4 43.5 116zM432 264l0 120 8.8 0 113.8-128-113.8-128-8.8 0 0 136z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFishBones = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;